import { cardContainerMultiColumnStyles as styles } from "@insite/content-library/Components/CardContainerMultiColumn";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.gridItem = {
    ...styles.gridItem,
    css: css`
        ${styles.gridItem?.css}
        padding: 8px;
    `,
};

styles.cardDivider = {
    ...styles.cardDivider,
    css: css`
        ${styles.cardDivider?.css}
        padding: 16px;
        height: 100%;
        width: 100%;
        overflow: hidden;
        border-bottom: 0;
        border: 1px solid ${getColor(colorStrings.commonBorder)};
        border-radius: 4px;
    `,
};
